import React from 'react';
import { heroImg } from '../assets';
import { toast, Toaster } from 'react-hot-toast';

const Contact = () => {
    const FORM_EMAIL = "03e11fe0314dc8a7056f9d97fc9461c5";

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.target;
        const formData = new FormData(form);
        
        const loadingToast = toast.success('Poruka je uspješno poslana!', {
            position: 'bottom-center'
        });
        form.reset();
        try {
            const response = await fetch(`https://formsubmit.co/${FORM_EMAIL}`, {
                method: 'POST',
                body: formData,
                headers: {
                    'Accept': 'application/json'
                }
            });
            
            if (!response.ok) throw new Error('Network response was not ok');

           
        } catch (error) {
            console.error('Error:', error);
        } finally {
            toast.dismiss(loadingToast);
        }
    };

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 bg-gradient-to-b from-primary-50 to-white">
            <Toaster 
                position="bottom-center"
                toastOptions={{
                    duration: 2000,
                    style: {
                        background: '#333',
                        color: '#fff',
                    },
                }}
            />
            {/* Left side - Form */}
            <div className="px-8 md:px-16 py-20 bg-gradient-to-b from-primary-50 to-white animate-fade-in-left">
                <div className="max-w-xl mx-auto">
                    <h2 className="text-4xl font-bold mb-8 bg-gradient-to-r 
                                from-primary-600 to-primary-800 bg-clip-text text-transparent">
                        Kontaktirajte nas
                    </h2>
                    
                    <form 
                        action={`https://formsubmit.co/${FORM_EMAIL}`} 
                        method="POST"
                        className="space-y-6"
                        onSubmit={handleSubmit}
                    >
                        {/* FormSubmit Configuration */}
                        <input type="hidden" name="_subject" value="Novi upit sa LuxEnergy weba" />
                        <input type="hidden" name="_template" value="table" />
                        <input type="hidden" name="_captcha" value="false" />
                        <input type="hidden" name="_next" value={window.location.origin} />
                        <input type="hidden" name="_format" value="json" />

                        {/* Honeypot */}
                        <input type="text" name="_honey" style={{ display: 'none' }} />

                        <div className="form-control">
                            <label className="label">
                                <span className="label-text text-gray-700">Ime i prezime</span>
                            </label>
                            <input 
                                type="text"
                                name="name"
                                placeholder="Vaše ime i prezime"
                                className="input input-bordered w-full bg-white text-gray-700
                                         focus:border-primary-500 hover:border-primary-400 
                                         transition-colors duration-300 placeholder-gray-400"
                                required
                            />
                        </div>

                        <div className="form-control">
                            <label className="label">
                                <span className="label-text text-gray-700">Email adresa</span>
                            </label>
                            <input 
                                type="email"
                                name="email"
                                placeholder="vasa-adresa@email.com"
                                className="input input-bordered w-full bg-white text-gray-700
                                         focus:border-primary-500 hover:border-primary-400 
                                         transition-colors duration-300 placeholder-gray-400"
                                required
                            />
                        </div>

                        <div className="form-control">
                            <label className="label">
                                <span className="label-text text-gray-700">Vaša poruka</span>
                            </label>
                            <textarea 
                                name="message"
                                placeholder="Kako vam možemo pomoći?"
                                rows="5"
                                className="textarea textarea-bordered h-32 w-full bg-white text-gray-700
                                         focus:border-primary-500 hover:border-primary-400 
                                         transition-colors duration-300 placeholder-gray-400"
                                required
                            />
                        </div>

                        <button 
                            type="submit"
                            className="btn bg-primary-600 hover:bg-primary-700 text-white border-none
                                     w-full hover:scale-105 transition-all duration-300"
                        >
                            Pošalji poruku
                        </button>
                    </form>
                </div>
            </div>

            {/* Right side - Image with gradient overlay */}
            <div className="relative min-h-[300px] md:min-h-[500px] md:h-[calc(100vh-80px)] 
                            animate-fade-in-right p-4 md:p-12">
                <div className="md:sticky md:top-20 h-full md:h-[calc(100vh-20rem)] w-full">
                    <div className="relative w-full h-full rounded-2xl overflow-hidden shadow-lg md:shadow-2xl 
                                  bg-white p-1 md:p-2 hover:shadow-primary-200/50 transition-shadow duration-300">
                        {/* Dark overlay for better text readability */}
                        <div className="absolute inset-0 z-10" />
                        
                        <img 
                            src={heroImg}
                            alt="Solar Panels"
                            className="w-full h-full object-cover rounded-xl"
                        />
                        
                        <div className="absolute inset-x-4 md:inset-x-8 bottom-4 md:top-8 z-20 text-white">
                            <h3 className="text-2xl md:text-3xl font-bold mb-2">
                                Spremni smo pomoći
                            </h3>
                            <p className="text-gray-100 text-base md:text-lg max-w-md">
                                Naš tim stručnjaka je tu da odgovori na sva vaša pitanja
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;